import { setCookie } from 'nookies';
import PropTypes from 'prop-types';
import { getTopBannerUrl } from '@/utils/espotUtils';

import Icon from '@/components/common/iconedLinks/Icon';
import MillesimaLink from '@/components/common/MillesimaLink';

import styles from './TopBannerEspot.module.scss';
import { COOKIES } from '@/constants/cookies';
import { URLS } from '@/constants/urls';

export const TopBannerEspot = ({ espot, topBannerAlreadyClosed, setTopBannerAlreadyClosed, contentClassname }) => {
  const { contentTitle, htmlContent, img, label, url } = espot;

  const cookieOptions = {
    path: '/',
    maxAge: COOKIES.TOP_BANNER_ESPOT.LIFETIME
  };

  const handleCloseTopBanner = () => {
    setCookie({}, `${COOKIES.TOP_BANNER_ESPOT.NAME}${espot._id}`, new Date(), cookieOptions);
    setTopBannerAlreadyClosed(true);
  };

  return (!topBannerAlreadyClosed ?
    <div className={styles.container} data-test-id="top-banner-espot">
      {
        htmlContent ? (
          <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
        ) : (
          <div
            style={{ backgroundImage: `url(${getTopBannerUrl(img)})` }}
            className={styles.banner}
          >
            <div className={`${contentClassname} ${styles.layout}`} data-test-id="layout">
              <div className={styles.content}>
                {contentTitle && <div className={styles.title}>{contentTitle}</div>}
                {url && (
                  <MillesimaLink
                    href={url}
                    customClassName={{ container: styles['action-container'], link: styles.action }}
                  >
                    {label}
                  </MillesimaLink>
                )}
              </div>

              <Icon
                src={URLS.ICON_CLOSE}
                alt="close"
                className={styles.icon}
                width={24}
                height={24}
                onClick={handleCloseTopBanner}
              />
            </div>
          </div>
        )
      }
    </div> :
    null
  );
};

TopBannerEspot.propTypes = {
  espot: PropTypes.object.isRequired,
  topBannerAlreadyClosed: PropTypes.bool.isRequired,
  setTopBannerAlreadyClosed: PropTypes.func.isRequired,
  contentClassname: PropTypes.string
};

export default TopBannerEspot;
